/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Bucket { 
    numero_mese?: number;
    anno?: number;
    totale_ricariche?: number;
    totale_pagato?: number;
    totale_in_attesa_pagamento?: number;
}

